import { inject } from 'inversify-props';
import { Vue } from 'vue-property-decorator';
import Component from 'vue-class-component';
import IAuthService from '../services/IAuthService';
import { Notification } from '../helpers/Notification';
import moment from 'moment';


@Component
export default class ComponentBase extends Vue {
    isLoading: boolean = false;
    @inject() private authService: IAuthService;

    moment = moment;
    notification = new Notification();
}
